export function getFormDateRangeFieldsDefaultTime() {
    const start = new Date();
    start.setHours(0, 0, 0);

    const end = new Date();
    end.setHours(23, 59, 59);

    return {
        start: start.toISOString(),
        end: end.toISOString(),
    };
}
